<template>
    <MainContent title="Conversacion">
        <template v-slot:header v-if="!loading">
            <span class="text-xl-left font-weight-bold">Asunto: {{ incidencia.asunto }}</span>
            <span class="text-xl-left font-weight-bold">Estado: {{ incidencia.estado }}</span>
        </template>

        <template v-slot:content v-if="!loading">
            <div v-for="mensaje in incidencia.mensajes" :key="mensaje.id">
                <BaseMensaje :mensaje="mensaje" :color="user.id == mensaje.user.id ? '#B8C6FF': '#B0FA9D'"/>
            </div>
            <div v-if="incidencia.estado !='Resuelto' && incidencia.estado !='Cerrado'">
                <InputMensaje :incidencia_id="incidencia.id" @refresh="getIncidencia()"/>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import InputMensaje from '@/components/backend/mensajes/InputMensaje';
    import BaseMensaje from '@/components/backend/mensajes/BaseMensaje';
    export default {
        data() {
            return {
                incidencia_id: this.$route.params.incidencia_id,
                incidencia: {
                    asunto: '',
                    estado: ''
                },
                loading: false,
                intervalo: null
            }
        },
        created() {
            this.getIncidencia();
            this.intervalo = setInterval(() => {
                this.getIncidencia();
            }, 15000);
        },
        computed: {
            user() {
                return this.$store.getters.getUser;
            }
        },
        methods: {
            getIncidencia() {
                this.loading = true;
                const params = {
                    filters: {
                    },
                    incidencia_id: this.incidencia_id,
                }
                this.$store.dispatch(this.config.getVuexAlias('back.mensajeria.show.incidencia'), params).then(res => {
                    this.incidencia = res.data.data;
                })

                this.loading = false;
            },

        },
        beforeDestroy() {
            clearInterval(this.intervalo);
        },
        components: {
            MainContent, BaseMensaje, InputMensaje
        }
    }
</script>